import React from 'react';
import './services.css';
import leetcodeIcon from '../../assets/leetcode.svg';
import codechefIcon from '../../assets/codechef.svg';
import codeforcesIcon from '../../assets/codeforces.svg';


const Services = () => {
    return (
        <section className="services section" id="services">
            <h2 className="section__title">Coding Profiles</h2>
            <span className="section__subtitle">My progress on different platforms</span>

            <div className="services__container container grid">
                <div className="services__content">
                    <div>
                        <img src={leetcodeIcon} alt="LeetCode" className="services__icon" />
                        <h3 className="services__title">
                            LeetCode <br /> Profile
                        </h3>
                    </div>

                    <a
                        className="services__button"
                        href="https://leetcode.com/adityacyan"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View More
                        <i className="uil uil-arrow-right services__button-icon"></i>
                    </a>
                </div>

                <div className="services__content">
                    <div>
                        <img src={codechefIcon} alt="CodeChef" className="services__icon" />
                        <h3 className="services__title">
                            CodeChef <br /> Profile
                        </h3>
                    </div>

                    <a
                        className="services__button"
                        href="https://www.codechef.com/users/raw_glue_26"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View More
                        <i className="uil uil-arrow-right services__button-icon"></i>
                    </a>
                </div>

                <div className="services__content">
                    <div>
                        <img src={codeforcesIcon} alt="Codeforces" className="services__icon" />
                        <h3 className="services__title">
                            Codeforces <br /> Profile
                        </h3>
                    </div>

                    <a
                        className="services__button"
                        href="https://codeforces.com/profile/adityacyan"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View More
                        <i className="uil uil-arrow-right services__button-icon"></i>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Services;
